const routePaths = {
    referenceLibrary: '/reference-library',
    guidelineTraining: '/guideline-training',
    supportingScan: '/supporting-scan',
    verify: '/verify',
};

export default routePaths;
